import ObtemIndices from './ObtemIndices';
import type { DadosPessoa } from './tipos';

/**
 * Implementaçao do endpoint GET /indices para busca de pessoas
 */
export default class ObtemIndicesPessoas extends ObtemIndices<DadosPessoa> {
  protected readonly tipoDeDado: 'pessoa' = 'pessoa';
}